import Button from "./Button";
import { useHistory } from 'react-router-dom';
import idle from '../assets/Idle.gif'
import idle2 from '../assets/Idle2.gif'
import waiting from '../assets/waiting.gif'
import React from "react";
import { ReadyUp, StartGame } from "./WebRTC/Rtc";



let peerReady = false;
let isReady = false

const RunCard = ({name, highscore, players, picture, runId, isLobby, isMine}) => {

    const history = useHistory();
    const SelectedRun = {
        id: runId,
        photoURL: picture,
        player: name,
        players: players
    }

    return (
        <div className='RunCard'>
            <div style={{backgroundColor:'#616161', width:'100%', height:'5rem', marginBottom:'3.5rem'  }}>
            {isLobby ? <h3 style={{marginTop:'0', display:'block'}}>{name}</h3> :<img src={picture} style={{borderRadius:'100%', marginTop:'0.25rem', boxShadow: '0px 0px 5px #000000', width:'120px', height:'120px'}} alt=""></img>}
            </div>
            {isLobby ? isMine ?  <img src={idle} style={{width:'100%'}} alt=""></img> : <img src={waiting} style={{maxWidth:'100%'}} alt=""></img> : 
            <React.Fragment>
                <h3>{name}</h3>
                <p>HIGH-SCORE: {highscore}</p>
                <p>{players} / 2</p>
            </React.Fragment>
            }
            {isLobby ? isMine ? <Button id='myBtn' onClick={(e) => {ReadyClickHandler(e)}} text="READY?" color='#616161'></Button> : <p className="header" style={{transition:'500ms'}} >Ready</p> : <Button onClick={(e) => {ClickHandler(e)}} text="Join" color='#616161'></Button>}
        </div>
    )

    function ClickHandler(e) {
        e.preventDefault();
        history.push("/lobby#" + runId, {Run: SelectedRun})
      }
    
    function ReadyClickHandler(e){
        e.preventDefault();
        if (isReady){
            isReady = false;
        }else isReady = true
        ReadyUp(isReady, true)
        readyUpDom({Ready: isReady}, true)
        StartGame(isReady, peerReady)
    }

    
}


RunCard.defaultProps = {
    name: "JOHN WICK",
    picture: 'https://picsum.photos/120'
}

export function peerJoined(options){
    var peerCard = document.querySelectorAll('.RunCard')[1] 
    peerCard.querySelector('h3').innerHTML =  options.user
    peerCard.querySelector('img').src = idle2
}

export function readyUpDom(options, isFromMe){
    var btn = document.querySelector('.RunCard button')
    var lbl = document.querySelector('.RunCard p')
    if (options.Ready && isFromMe){
        btn.classList.add('ready')
        btn.innerHTML = 'READY'
    }
    else if (!options.Ready && isFromMe){
        btn.classList.remove('ready')
        btn.innerHTML = 'READY?'
    }
    else if (options.Ready && !isFromMe){
        lbl.classList.add('ready')
        lbl.innerHTML = 'READY'
    }
    else if (!options.Ready && !isFromMe){
        lbl.classList.remove('ready')
        lbl.innerHTML = 'READY?'
    }
}

export function setPeerReady(rdy){
    peerReady = rdy
}
export {isReady}
export default RunCard
